import styled from '@emotion/styled';
import React from 'react';

const HiddenAnchor = styled('a')(() => ({
  position: 'absolute',
  inset: 0,
  opacity: 0,
  pointerEvents: 'none'
}));

const HiddenLink = ({ href }) => <HiddenAnchor href={href} aria-hidden="true" tabIndex={-1} />;

export default HiddenLink;
